<script>
import Modal from './Modal.vue';
import { layoutComputed } from "@/state/helpers";

export default {
  props: {
    topbarControls: {
      type: Object,
      required: false
    }
  },
  components: {
    Modal
  },
  computed: {
    ...layoutComputed,
    showAddNew() {
      const isOaks = this.currentPractice && this.currentPractice.name === "Oaks Healthcare";
      const isQuickLinks = this.$route && this.$route.params && this.$route.params.categoryName === "quicklinks";
      if (isOaks && isQuickLinks) return false;
      return true;
    }
  },
  data() {
    return {
      isModalVisible: false
    }
  },
  methods: {
    toggleModal() {
      this.isModalVisible = !this.isModalVisible;
    }
  },
  mounted() {
  }
};
</script>
<template>
  <div v-if="showAddNew" class="d-flex align-items-center justify-content-between pl-3 border-right-dark">
    <span class="font-weight-medium mb-0">Add New: </span>
    <img class="align-self-center ml-2 cursor-pointer" @click="toggleModal"
    src="@/assets/images/addbtn.svg" alt="">
    <Modal
      :isModalVisible="isModalVisible"
      :topbarControls="topbarControls"
      :toggleModal="toggleModal"
    />
  </div>
</template>